import React from "react";

function ManagedUserTable({ users, onOpenModal }) {
  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped align-middle text-center">
        <thead className="table-light">
          <tr>
            <th>帳號</th>
            <th>姓名</th>
            <th>最新收縮壓</th>
            <th>最新舒張壓</th>
            <th>最新心律</th>
            <th>平均收縮壓</th>
            <th>平均舒張壓</th>
            <th>平均心律</th>
            <th>異常</th>
            <th>最新記錄時間</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.userId}>
              <td>{u.account}</td>
              <td>{u.name}</td>
              <td>{u.latestSystolic ?? "-"}</td>
              <td>{u.latestDiastolic ?? "-"}</td>
              <td>{u.latestHeartRate ?? "-"}</td>
              <td>{u.avgSystolic?.toFixed(1) ?? "-"}</td>
              <td>{u.avgDiastolic?.toFixed(1) ?? "-"}</td>
              <td>{u.avgHeartRate?.toFixed(1) ?? "-"}</td>
              <td>{u.hasBPAbnormal ? "⚠️" : "✅"}</td>
              <td>{u.updatedAtBP?.slice(0, 16) ?? "-"}</td>
              <td>
                <div className="d-grid gap-1">
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => onOpenModal("bloodPressure", u)}
                  >
                    新增紀錄
                  </button>
                  <button
                    className="btn btn-sm btn-secondary"
                    onClick={() => onOpenModal("bloodPressureHistory", u)}
                  >
                    歷史記錄
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ManagedUserTable;
